import React, { useEffect, useState } from "react";
import eventBus from "src/utils/eventBus";

const ExplainModal: React.FC = () => {
    const [message, setMessage] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isHandlingBack, setIsHandlingBack] = useState(false);

    useEffect(() => {
            const onShowExplain = (data: { message }) => {
                setMessage(data.message);
                setTimeout(() => setIsVisible(true), 10);
                if (window.history.state !== "modal-open") {
                    window.history.pushState("modal-open", "", window.location.pathname);
                }
        };

        eventBus.on("explainModal:show", onShowExplain);

        return () => {
            eventBus.off("explainModal:show", onShowExplain);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = "hidden";

            const handleBackButton = () => {
                if (!isVisible || isHandlingBack) return;

                setIsHandlingBack(true);
                closeModal();

                setTimeout(() => setIsHandlingBack(false), 200);
            };

            window.addEventListener("popstate", handleBackButton);

            return () => {
                document.body.style.overflow = "auto";
                window.removeEventListener("popstate", handleBackButton);
                setIsHandlingBack(false);
            };
        }
    }, [isVisible, isHandlingBack]);

    const closeModal = () => {
        setIsVisible(false); 
        setTimeout(() => setMessage(null), 300);
    };

    if (!message) return null;
    

    return (
        <>
            <div className={`overlay ${isVisible ? "active" : ""}`} onClick={closeModal}></div>
            <div className={`modal fade ${isVisible ? "show" : ""} d-block`} tabIndex={-1} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-4 text-left" style={{ borderRadius: "8px" }}>
                        <div className="modal-body">
                            <h4 className="fw-bold mb-3">{message.title}</h4>
                            {message.content.map((item, index) => (
                                <p
                                key={index}
                                className="text-muted"
                                style={{
                                    whiteSpace: "pre-line",
                                    textIndent: "-7px",
                                    paddingLeft: "11px",
                                }}
                                >
                                    · {item}
                                </p>
                            ))}
                        </div>
                        <div className="modal-footer border-0">
                            <button 
                                type="button" 
                                className="btn btn-dark w-100 pt-3 pb-3" 
                                data-bs-dismiss="modal" 
                                onClick={closeModal}
                            >
                                확인
                            </button>
                        </div>                
                    </div>
                </div>
            </div>            
        </>
    );
};

export default ExplainModal;
